export default __webpack_public_path__ + "static/media/privacy-policy.258edc9c.pdf";